import React from "react";
import styles from "./News.module.scss";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import NrgPage from '../NrgPage.jsx';
import DocumentHead from '../../components/DocumentHead.jsx';
import CommonClientScripts from '../../components/CommonClientScripts.jsx';
import GenericHeader from '../../components/Header/GenericHeader.jsx';
import JourneyContinueBox from '../../components/JourneyContinueBox/JourneyContinueBox.jsx';
import PipedContentHeader from '../../components/PipedContentHeader/PipedContentHeader.jsx';
import UnderPipePanel from '../../components/UnderPipePanel/UnderPipePanel.jsx';
import PipedContentFooter from '../../components/PipedContentFooter/PipedContentFooter.jsx';
import IconListPanel from '../../components/IconListPanel/IconListPanel.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';
import NewsPanel from '../../components/NewsPanel/NewsPanel.jsx';

import ScrollItemManager from '../../utils/ScrollItemManager'
import StyledButtonPanel from '../../components/StyledButtonPanel/StyledButtonPanel.jsx';
import { changePageTitle } from "../../utils/pageSetup/pageSetup";
import PostPopUp from "../../components/PostPopUp/PostPopUp";
import BackTop from "../../components/BackTop/BackTop";

class News extends NrgPage {
    constructor(props) {
        super(props);

        this.state = {
            isPostOpen: false,
            postObj: {}
        };

        this.page = 'news';

        this.generalHeaderRef = React.createRef();
        this.styledButtonRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('keydown', e => this.handleKeyDown(e));

        changePageTitle(this.page);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }
    handleKeyDown(event) {
        if (event.keyCode === 27) { // checks whether the pressed key is "ESC"
            if (this.state.isPostOpen) {
                this.setState({ isPostOpen: false }, () => {
                    this.closePost();
                })
            }
        }
    }
    closePost = () => {
        this.setState({ isPostOpen: false });
        window.history.replaceState(null, null, "/news");
    }
    openPost = (postObj) => {
        this.setState({ isPostOpen: true, postObj: postObj });
    }
    scrollToTop() {
        this.generalHeaderRef._moveDown();
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>
                    <PostPopUp closePost={() => this.closePost()} isOpen={this.state.isPostOpen} postObj={this.state.postObj}
                        loadInPreviousArticle={(itemIndex) => this.styledButtonRef.loadInPreviousArticle(itemIndex)}
                        loadInNextArticle={(itemIndex) => this.styledButtonRef.loadInNextArticle(itemIndex)}
                    />

                    {/* <ReactCSSTransitionGroup
                        transitionName="news"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        {newsPanel}
                    </ReactCSSTransitionGroup> */}

                    <GenericHeader onRef={ref => (this.generalHeaderRef = ref)} page={this.page} newsActions={this.newsActions} />

                    <PipedContentHeader page={this.page} />
                    <StyledButtonPanel onRef={ref => (this.styledButtonRef = ref)} openPost={(postObj) => this.openPost(postObj)} />

                    <PipedContentFooter />

                    <BackTop scrollTop={() => this.scrollToTop()} />
                    <Footer />

                </PageTransitioner>
            </div>
        );
    }
}

export default News;
